module.exports = __webpack_public_path__ + "img/0.aa9cde6c.png";